
@if (selectedCompanyGroup === 'ANL') {
  <app-style-anl></app-style-anl>
}
@if (selectedCompanyGroup !== 'ANL') {
  <app-style-gho></app-style-gho>
}

<div id="content_container" [ngClass]="customClass + ' ' + selectedCompanyGroup">
  @if (isHelpdesk && showMainInterface) {
    <app-selected-dealer-nav-bar
      id="selectedDealerBar"
      class="px-3 py-1 d-block bg-secondary text-bold fixed-top white-text bg-dark"
      >
    </app-selected-dealer-nav-bar>
  }
  @if ((environmentName !== 'production' ) && isLoggedIn$) {
    @if (showMainInterface && showDevInfo) {
      <div
        class="p-2 btn btn-light position-fixed fw-bold dev-info"
        >
        {{ environmentName }}
        @if (environmentApiWarning) {
          <small class="bg-danger px-1"> {{environmentApiWarning}}</small>
        }
        <app-test-settings/>
        <span class="ms-2 text-muted" style="cursor:pointer;font-size:0.75rem;line-height:1" (click)="showDevInfo = false">&#x2715;</span>
      </div>
    }
  }
  @if ((showMainInterface && isLoggedIn$ | async) && !kioskMode) {
    <nav
      class="navbar navbar-expand-lg navbar-dark" [class.fixed-top]="navbarFixed"  [class.hasBasketBar]="showBasketBar"
      id="header"
      [ngClass]="headerClass"
      [class.hidden]="!isNavbarVisible"
      >
      @if (applicationService.newVersionAvailable) {
        <div
          class="p-2 position-fixed fw-bold bg-success rounded text-white clickable"
          style="right: 25px; bottom: 30px; z-index: 99999"
          (click)="updateApplication()"
          >
          {{ "NEW_VERSION" | translate }}
        </div>
      }
      <div class="container" [ngClass]="{ preview: isPreview }">
        @if (showMainInterface) {
          <div
            class="ps-0 row collapse navbar-collapse d-flex justify-content-md-between"
            [ngClass]="showNav ? '' : 'hidden'"
            id="navbarSupportedContent"
            >
            <div class="col-3 col-sm-1 d-flex align-items-center menu-container">
              <app-mega-menu class="w-auto"></app-mega-menu>
            </div>
            <div class="col-2 col-md-2 col-xl-2 logo-container">
              <app-logo
                class="d-flex align-items-center w-100"
                #logo
                [selectedCompanyGroup]="selectedCompanyGroup"
                [ngClass]="selectedCompanyGroup"
                (clickOutside)="logo.showCompanyDropdown = false"
              ></app-logo>
            </div>
            <div class="col-12 col-sm-12 col-md-6 col-lg-5 d-flex justify-content-start ps-0">
              @if (isDealer && !isPreview) {
                <app-search-bar
                  id="searchbar"
                  class="px-0 position-relative d-flex justify-content-start w-100"
                  ><app-quick-settings class="md-px-3 sm-ps-0" [placement]="'bottom'"></app-quick-settings>
                </app-search-bar>
              }
            </div>
            @if (isPreview && !showIcons) {
              <div
                class="px-0 col-md-4"
              ></div>
            }
            @if (!isPreview) {
              <div
                class="col pt-1 pe-1 counters d-flex pe-lg-1 pe-xl-2"
                >
                @if (applicationService.getSelectCompanyGroupCode() === 'ANL' && isDealer && showIcons) {
                  <app-juncker-loyalty-count class="me-0 me-sm-2" [compact]="true"/>
                }
                @if (showIcons) {
                  <span
                    [routerLink]="selectedCompanyGroup + '/dealeroverview'"
                    [ngbTooltip]="'MY_ACCOUNT' | translate"
                    class="pt-1 mt-1 d-none clickable dealer-overview-icon d-sm-inline-block"
                    style="transform: translateY(-1px)"
                    >
                    <i id="menuButtonAccountIcon" class="material-icons light me-2">
                      account_circle</i
                      ></span
                      >
                    }
                    @if (showIcons) {
                      <app-alert-counter
                        (alertDropdownOpen)="closeBasketPreview()"
                      ></app-alert-counter>
                    }
                    @if (isDealer && showIcons) {
                      <app-dropshipment-counter class="d-none d-sm-block"></app-dropshipment-counter>
                    }
                    @if (
                      isDealer &&
                      accountService.getAccountAccessOption('CanAccessBaskets')
                      ) {
                      <app-basket-preview
                        #basketPreview
                        id="basketPreview"
                        class="me-2"
                      ></app-basket-preview>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </nav>
      }

      <p-scrollTop styleClass="custom-scrolltop global-to-top" [threshold]="100" icon="pi pi-arrow-up"></p-scrollTop>

      @if (showSpinner) {
        <div
          class="h-100 justify-content-center align-items-center"
          >
          <div class="spinner-grow text-primary spinner-loader d-flex align-items-center justify-content-center" role="status">
            <span class="visually-hidden">{{ "LOADING" | translate }}...</span>
            <i class="material-icons text-white">pedal_bike</i>
          </div>
        </div>
      }
      @if (screenSaverActive && showMainInterface) {
        <app-screen-saver
          (active)="setScreenSaver($event)"
          >
          @if (selectedCompanyGroup === 'ANL') {
            <img
              class="logo"
              src="./assets/images/Accentry-logo-black.svg"
              alt="Accentry"
              title="Accentry"
              />
          }
          @if (selectedCompanyGroup === 'GHO') {
            <img
              class="logo"
              src="./assets/images/Ghost-logo.png"
              alt="Ghost - Accentry"
              title="Ghost - Accentry"
              />
          }
          @if (selectedCompanyGroup === 'VAR') {
            <img
              class="logo"
              src="./assets/images/tunturi-accell-white.png"
              alt="Tunturi Sweden"
              title="Tunturi Sweden - Accentry"
              />
          }
          @if (selectedCompanyGroup === 'LAP') {
            <img
              class="logo"
              src="./assets/images/Acccell-sud.png"
              alt="Lapierre - Accentry"
              title="Lapierre - Accentry"
              />
          }
          @if (selectedCompanyGroup === 'COM') {
            <img
              class="logo"
              src="./assets/images/Comet-logo.png"
              alt="Comet - Accentry"
              title="Comet - Accentry"
              />
          }
          @if (selectedCompanyGroup === 'WG') {
            <img
              class="logo"
              src="./assets/images/Winora-logo.png"
              alt="Winora - Accentry"
              title="Winora - Accentry"
              />
          }
          @if (selectedCompanyGroup === 'WG') {
            <img
              class="logo"
              src="./assets/images/Winora-bike-parts-logo.svg"
              alt="E. Wiener Bike Parts - Accentry"
              title="E. Wiener Bike Parts - Accentry"
              />
          }
        </app-screen-saver>
      }
      <main id="wrapper" class="wrapper" [ngClass]="{'hasBasketBar': showBasketBar}">
        <div class="row">
          <div class="" [ngClass]="showBasketBar ? 'col-12' : ''">
            <router-outlet (activate)="scrollTop($event)"></router-outlet>
          </div>
          @if (showBasketBar && showMainInterface) {
            <div [hidden]="basketBarInvisible">
              <app-basket-bar/>
            </div>
          }
        </div>
      </main>
      @if (showMainInterface && !kioskMode) {
        <app-footer
          id="footer"
          [selectedCompanyGroup]="selectedCompanyGroup"
          class="d-flex doNotPrint"
          >
        </app-footer>
      }

      @if (showMainInterface && !kioskMode && showStockNotifcations) {
        <app-stock-notifications-container
        ></app-stock-notifications-container>
      }
      <div id="modalContainer"></div>
      <div id="alertContainer"></div>
      @if (showMainInterface && !kioskMode) {
        <app-show-compare-button
          class="doNotPrint"
        ></app-show-compare-button>
      }
      @if (kioskCheckerActive) {
        <app-leave-kiosk-mode-modal
          (kioskCheckerActive)="disableKioskMode()"
          (onExitKioskMode)="disableKioskMode()"
        ></app-leave-kiosk-mode-modal>
      }
    </div>
